module.exports = __webpack_public_path__ + "static/MarketMan-606c02525b7a29faa6cd4b901d0b0f22.jpg";